// File: /src/components/ClientCard.js

import React from 'react';
import IconButton from '@mui/material/IconButton';
import myColorIcon from '../assets/color-circle.png';
import '../styles/GridClients.css';

const ClientCard = ({
	client,
	borderColor,
	isSelected,
	onToggleSelect,
	onColorChange,
	onClick,
	viewMode,
}) => {
	const handleColorPickerClick = (e) => {
		e.stopPropagation();
		document.getElementById(`colorPicker-${client.id}`).click();
	};

	const handleColorInputChange = (e) => {
		e.stopPropagation();
		onColorChange(client.id, e.target.value);
	};

	// Estilos específicos com base no modo de visualização
	const cardClassName =
		viewMode === 'grid' ? 'grid-client-card' : 'list-client-card';

	const cardStyle =
		viewMode === 'grid'
			? { cursor: 'pointer', '--card-border-color': borderColor }
			: {
					'--card-border-color': borderColor,
					borderTop: `4px solid var(--card-border-color)`,
					cursor: 'pointer',
			  };

	return (
		<div className={cardClassName} style={cardStyle} onClick={onClick}>
			{viewMode === 'list' ? (
				<div className="list-client-header">
					<input
						type="checkbox"
						className="grid-client-checkbox"
						checked={isSelected}
						onClick={(e) => e.stopPropagation()}
						onChange={onToggleSelect}
					/>
					<h3>{client.name}</h3>
					<IconButton
						className="grid-color-picker-btn"
						onClick={handleColorPickerClick}
						size="small"
						disableRipple
					>
						<img
							src={myColorIcon}
							alt="Escolher cor"
							className="grid-custom-icon"
						/>
					</IconButton>
				</div>
			) : (
				<>
					<input
						type="checkbox"
						className="grid-client-checkbox"
						checked={isSelected}
						onClick={(e) => e.stopPropagation()}
						onChange={onToggleSelect}
						style={{ marginBottom: '0.5rem' }}
					/>
					<h3>{client.name}</h3>
				</>
			)}

			<p>{client.email}</p>

			{viewMode === 'grid' && (
				<IconButton
					className="grid-color-picker-btn"
					onClick={handleColorPickerClick}
					size="small"
					disableRipple
				>
					<img
						src={myColorIcon}
						alt="Escolher cor"
						className="grid-custom-icon"
					/>
				</IconButton>
			)}

			<input
				id={`colorPicker-${client.id}`}
				type="color"
				className="grid-card-color-input"
				value={borderColor}
				onClick={(e) => e.stopPropagation()}
				onChange={handleColorInputChange}
				style={{ display: 'none' }}
			/>
		</div>
	);
};

export default ClientCard;
